import { Dispatch, memo, SetStateAction, useCallback } from 'react';

import { toast } from '@/lib/v2/components';
import { LoadingIcon } from '@/lib/v2/icons/animated';

import { SendActionsPostMessage } from '@/src/compat/sendActionsPostMessage';
import { useSenderModal } from '@/src/modules/ContactsModule/hooks/useSenderModal';
import { ISenderData } from '@/src/presentation/types/interfaces/ISenderData.interface';

import FormSender from '@/modules/ContactsModule/components/CreateSenderModal/FormSenderContent/FormSender';

interface FormSenderContentProps {
  onClose: Dispatch<SetStateAction<boolean>>;
  onSenderComplete?: (complete: boolean) => void;
  isStep?: boolean;
}

const FormSenderContent = ({ onClose, isStep, onSenderComplete }: FormSenderContentProps) => {
  const { submitData, isLoadingSenderList, senderData, isEmailCompany, saveIsLoading } =
    useSenderModal({
      initialNewCreateSender: !isStep,
    });

  const handleSubmitFormData = useCallback(
    async (formValue: ISenderData) => {
      const response = await submitData(formValue);
      const { ok, message } = response;
      if (ok) {
        toast({
          title: message,
        });
        onClose(false);
        if (!isStep) updateListSenderV1();
        onSenderComplete?.(true);
      } else {
        toast({
          title: message,
          variant: 'error',
        });
        onSenderComplete?.(false);
      }
    },
    [isStep, onClose, onSenderComplete, submitData]
  );

  const updateListSenderV1 = () => {
    SendActionsPostMessage('UpdateListSender', 'Campaigns');
  };

  if (isLoadingSenderList) {
    return (
      <div className="flex w-full items-center justify-center py-4">
        <LoadingIcon />
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col gap-4 pt-4">
      <FormSender
        defaultValues={senderData}
        isEmailCompany={isEmailCompany}
        isLoading={saveIsLoading}
        isNewSender={!isStep}
        onSubmitFormData={handleSubmitFormData}
      />
    </div>
  );
};

export default memo(FormSenderContent);
